import { createSlice } from '@reduxjs/toolkit'

const VALID_THEMES = new Set(['light', 'dark'])
const raw = localStorage.getItem('app-theme')
const saved = VALID_THEMES.has(raw) ? raw : 'light'

const themeSlice = createSlice({
  name: 'theme',
  initialState: { mode: saved },
  reducers: {
    setTheme(state, action) {
      const value = VALID_THEMES.has(action.payload) ? action.payload : 'light'
      state.mode = value
      localStorage.setItem('app-theme', value)
    },
  },
})

export const { setTheme } = themeSlice.actions
export default themeSlice.reducer
